var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.992 30.849"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-file-play",
    d: "M9.64 11.572l9.64 6.748-9.64 6.748V11.572zm16.081-4.671a27.316 27.316 0 00-2.626-3 27.323 27.323 0 00-3-2.626C18.541.136 17.788.004 17.356.004H2.41A2.413 2.413 0 00.001 2.41v26.029a2.413 2.413 0 002.41 2.41h22.171a2.413 2.413 0 002.41-2.41v-18.8c0-.432-.132-1.185-1.271-2.739zm-3.99-1.64a26.3 26.3 0 012.187 2.451H19.28v-4.64a26.268 26.268 0 012.451 2.186zm3.333 23.178a.489.489 0 01-.482.482H2.41a.489.489 0 01-.482-.482V2.41a.489.489 0 01.482-.482h14.942v6.744a.964.964 0 00.964.964h6.748z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "789c455e38bfd2a2e77c236f63207a6e.svg";
export { SvgFilePlay as ReactComponent };